import { render, staticRenderFns } from "./InputTag.vue?vue&type=template&id=6c9b5816&scoped=true&lang=pug"
import script from "./InputTag.vue?vue&type=script&lang=js"
export * from "./InputTag.vue?vue&type=script&lang=js"
import style0 from "./InputTag.vue?vue&type=style&index=0&id=6c9b5816&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9b5816",
  null
  
)

export default component.exports